import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Calendar as CalendarIcon, Clock } from 'lucide-react';

export const DateField = ({ value, onChange, format = 'long', placeholder, testId }) => {
  const fmt = (d) => format === 'monthday'
    ? d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
    : format === 'iso'
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
      : d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  return (
    <div className="flex gap-1">
      <Input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} />
      <Popover>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" size="icon" className="flex-shrink-0" data-testid={testId ? `${testId}-picker` : undefined}>
            <CalendarIcon className="h-4 w-4 text-terracotta" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar mode="single" onSelect={(d) => d && onChange(fmt(d))} initialFocus />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export const TimeField = ({ value, onChange, placeholder, testId }) => {
  const fmt = (t) => {
    const [h, m] = t.split(':').map(Number);
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${ampm}`;
  };
  return (
    <div className="flex gap-1">
      <Input value={value || ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid={testId} />
      <Popover>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" size="icon" className="flex-shrink-0" data-testid={testId ? `${testId}-picker` : undefined}>
            <Clock className="h-4 w-4 text-terracotta" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-3" align="end">
          <input type="time" className="border border-input rounded-md px-2 py-1.5 text-sm bg-white"
            onChange={(e) => e.target.value && onChange(fmt(e.target.value))}
            data-testid={testId ? `${testId}-clock` : undefined} />
        </PopoverContent>
      </Popover>
    </div>
  );
};
